module.exports = __webpack_public_path__ + "static/media/horizontalRectangle_indigo.edebce85.svg";